import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = (data) => {
  return request.post(
    'Acceptance/check_desks_busy_in_current_acceptance',
    data,
    'Не удалось проверить занятость столов в приемке',
    'Error'
  );
};

export const useCheckDesksBusyMutation = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
